<template>
  <div class="container public">
    <div class="row justify-content-center">
    <b-card
      border-variant="warning"
      header="Сообщение для пользователя"
      header-bg-variant="transparent"
      align="center"
      class="col-lg-4"
    >
      <b-card-text>{{msg}}</b-card-text>
    </b-card>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      msg: {
        type: String,
        default: 'Нет прав!'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>
